import { MultiLanguageWrapper } from "@iddataweb/idw-common-ui/types";
import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithBody } from "@utils/http-util";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { MessagingTemplate } from "@idw-types/data/messaging-template";
import { MessagingTemplateTypes } from "@enums/messaging-template-types";

export const createMessagingTemplateRequest = async (
    template: string,
    name: string,
    companyId: string,
    relyingPartyId: string,
    type: MessagingTemplateTypes,
    languageFiles: Partial<MultiLanguageWrapper<string>>
): Promise<GenericNetworkResponse<MessagingTemplate>> => {
    const route = apiRoutes.axnadminCore.messagingTemplate;
    const body: Partial<MessagingTemplate> = {
        template,
        name,
        companyID: companyId,
        relyingPartyID: relyingPartyId,
        type,
        languageFiles
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.POST, route, body);
    return { data, error, body };
};